module.exports = __webpack_public_path__ + "media/images/contactese/gris_ccentral-bb3c7979c0a53529100529608bca4a9c.svg";